import { Alert, Grid, Link, Stack } from "@mui/material";
import React from "react";
import { useQuery } from "react-query";
import MenuItem from "../MenuItem";
import { useTranslation } from "react-i18next"
import { Feature } from "../../models/api";
import { fetchServices } from "../../framework/services";
import ActionLoader from "../UI/ActionLoader/ActionLoader";


interface Props {}

export const viewable = (role: string, roles: string[]) => {
  return roles?.includes(role);
};

const SideMenu: React.FC<Props> = () => {


  const { t } = useTranslation();
  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );

  let features: Feature[] | undefined = data

  const [selectedFeature, setSelectedFeature] = React.useState<Feature | null>(
    null
  );


  if (isError)
    return (
      <Alert severity="error">An error occurred while fetching features.</Alert>
    );
  if (isLoading) return <ActionLoader position="fixed" />;

  const handleSelectUnLinkFeature = (feature: Feature) =>
    setSelectedFeature(feature);


  return (
    <Stack
      component={"aside"}
      maxWidth={380}
      bgcolor={"sideMenu.bg"}
      zIndex={1200}
      sx={{
        flexShrink: 0,
        position: "sticky",
        top: 0,
        transition: "500ms",
        borderRadius: "0px 10px 10px 0px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
        p: 1,

        overflowX: "hidden",
        overflowY: "auto",
        display: { xs: "none", lg: "block" },
      }}
    >
      <Stack justifyContent={"center"} sx={{py:5}} spacing={2}>
        {features &&
          features.length > 0 &&
          features.map((feature, index) => {
  
            return (
              <MenuItem
                onSelectUnLinkFeature={handleSelectUnLinkFeature}
                key={index}
                name={t(feature.name)}
                icon={feature.icon}
                hasChildren={feature.children.length > 0 ? true : false}
                color={"white"}
                feature={feature}
                slug={feature.slug}
                open={true}
              />
            );
          })}
      </Stack>
    </Stack>
  );
};

export default SideMenu;
